/*
 * MDB shim for MDBFormInline
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Deliveries/deliveryList.jsx
 */

import MUIBox from "@mui/material/Box";

export default function MDBFormInline({ children, className, style, ...rest }) {
    return (
        <MUIBox
            component="form"
            className={className}
            style={{ display: "flex", alignItems: "center", gap: 8, ...style }}
            {...rest}
        >
            {children}
        </MUIBox>
    );
}
